<template>
    <div
        class="travel-quote-step trip-info"
        :class="[`sub-step-${currentSubStep}`]"
    >
        <quote-step-header
            :key="currentSubStep"
            :title="
                currentInsureItem !== null
                    ? travelersItemsInsureTitle
                    : subStepFields.title
            "
            :subtitle="
                currentInsureItem !== null
                    ? travelersItemsInsureSubTitle
                    : subStepFields.subtitle
            "
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <template>
                <div class="form-row">
                    <div class="trip-travelers">
                        <div class="travelers-wrap">
                            <trip-traveler
                                v-for="(traveler, index) in form[stepName]
                                    .travelers"
                                :key="index"
                                :traveler="traveler"
                                :constants="constants"
                                :trans="trans"
                                :errors="errors"
                                :index="index"
                                @removeItem="removeTraveler"
                            />
                            <plus-button
                                @click="addTraveler"
                                :label="trans('trip_info.add_traveler')"
                            >
                            </plus-button>
                        </div>
                    </div>
                </div>
            </template>

            <div class="submit-row">
                <app-button
                    v-if="!showTravelersItemsInsure"
                    :disabled="disabledConditions"
                    :loading="loading"
                >
                    {{ "quote.welcome.next" | __ }}
                </app-button>

                <app-link-button
                    v-if="showTravelersItemsInsure"
                    @click="selectTravelsInsureItems"
                    :disabled="disabledConditions"
                    :loading="loading"
                >
                    {{ "quote.welcome.next" | __ }}
                </app-link-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import TripTraveler from "./TripTraveler.vue";
import moment from "moment";
import PlusButton from "../../Forms/PlusButton.vue";

export default {
    name: "TravelQuoteTripInfo",
    components: { TripTraveler, PlusButton },
    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["default"],
            currentInsureItem: null
        };
    },

    methods: {
        removeTraveler(index) {
            this.form[this.stepName].travelers.splice(index, 1);
        },
        addTraveler() {
            this.form[this.stepName].travelers = [
                ...this.form[this.stepName].travelers,
                ...[
                    {
                        name: "",
                        birth_date: null,
                        id: null,
                        mail: "",
                        sex: null
                    }
                ]
            ];
        },
        selectTravelsInsureItems() {
            this.currentInsureItem = this.constants.ITEMS[0];
        }
    },

    computed: {
        showTravelersItemsInsure() {
            if (this.subStep !== "items") {
                return false;
            }

            return this.stepFormFields.travelers.length > 1;
        },
        travelersItemsInsureTitle() {
            return this.trans("for_who_insure");
        },
        canMoveNext() {
            if (this.stepFormFields.travelers.length > 0) {
                return this.stepFormFields.travelers.every(traveler => {
                    return (
                        traveler.name &&
                        traveler.birth_date &&
                        traveler.id &&
                        traveler.mail &&
                        traveler.sex
                    );
                });
            }
            return false;
        }
    }
};
</script>

<style lang="scss" scoped>
.trip-info {
    position: relative;
    width: 100%;

    .trip-travelers {
        display: flex;
        flex-direction: column;
        width: 90%;
        max-width: $tablet;

        .travelers-wrap {
            display: flex;
            flex-direction: column;
        }

        .add-traveler {
            display: flex;
            align-items: center;
            cursor: pointer;

            span.text {
                font-size: 20px;
                font-weight: $font-light;
                margin-right: 15px;
                color: $primary-blue;
            }

            span.icon {
                display: flex;
            }
        }
    }
}
</style>
